<div class="page-layout simple fullwidth">
    <!-- CONTENT -->
    <div class="content p-24 mat-white-bg"></div>
    <!-- / CONTENT -->
</div>

